<template>
  <v-container>
    <v-btn icon color="primary" class="light--text" @click="fetchData" :loading="loading">
      <v-icon color="primary" class="ms-2 light--text">mdi-download</v-icon>
    </v-btn>
  </v-container>
</template>
<script>
import { printInvoice } from "../methods/a4_invoice_new";
var QRCode = require("qrcode");
import moment from "moment";
export default {
  components: {},

  props: {
    invoice: {
      required: true,
    },
  },

  created() {},
  methods: {
    fetchData() {
      this.getCustomerDetails();
    },
    getCustomerDetails() {
      this.loading = true;
      this.$apollo
        .query({
          query: require("@/customer/api/getCustomerById.graphql"),
          variables: {
            id: this.invoice.customer,
          },
        })

        .then(data => {
          this.loading = false;
          if (data.data.getCustomerById) {
            this.customerDetails = data.data.getCustomerById;
            setTimeout(() => {
              this.printInvoice();
            }, 100);
          }
          this.loading = false;
        });
    },

    printInvoice() {
      let self = this;
      let qrCodeString = `
          \nInvoice Date : ${moment(new Date(parseInt(this.invoice.createdAt))).format("DD MMM YYYY")}
          \nTotal 0 Due : ${this.invoice.total.toFixed(2)}
          `;
      QRCode.toDataURL(qrCodeString, function(err, url) {
        console.log(err);
        console.log(self.invoice);
        self.invoice.qrCode = url;
        printInvoice(self.invoice, self.customerDetails);
      });
    },
    toDataURL(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },
  },
  data() {
    return {
      valid: true,
      imageUrl: "",
      customerDetails: null,
      loading: false,
    };
  },
};
</script>
